module.exports = __webpack_public_path__ + "img/tou_enable.dc94af2f.jpg";